import type { ApiConfig } from "@/Http/Http.d";
/**
 * @description: Api config
 * ⚠️⚠️：Please check the host before releasing the production environment, and do not use the sample host
 * If there are multiple services, you can import apis fields in modules
 */
const apiConfig: ApiConfig = {
	// Configure the default host
	defaultHost: {
		test_local: 'http://100.73.12.102:3000/',
		test: 'http://100.73.12.102:3000/',
		huidu: 'http://100.73.12.102:3000/',
		production: 'http://lcmp-api.longtrendssec.com/'
	},
	apis: {
		// if need to complete custom request host
		useCustomeHostApi: {
			customeHost: {
				test: 'localhost:300/', // This is just one example
				huidu: '', // TODO: need add
				production: '' // TODO: need add
			},
			serve: 'mock/userMock/useCustomeHost.json',
			path: 'module/getModuleList'
		},
		// Module CRUD
		getModuleListApi: {
			serve: 'mock/moduleMock/getModuleListApi.json',
			path: 'module/getModuleList'
		},
		getModuleByIdApi: {
			serve: 'mock/moduleMock/getModuleByIdApi.json',
			path: 'module/getModuleById'
		},
		addModuleApi: {
			serve: 'mock/moduleMock/addModuleApi.json',
			path: 'module/addModule'
		},
		updateModuleApi: {
			serve: 'mock/moduleMock/updateModuleApi.json',
			path: 'module/updateModule'
		},
		getCascadingModuleApi: {
			serve: 'mock/moduleMock/getCascadingModuleApi.json',
			path: '	module/getCascadingModule'
		},

		// Page CRUD	
		getPageListApi: {
			serve: 'mock/pageMock/getPageListApi.json',
			path: 'page/getPageList'
		},
		createPageApi: {
			serve: 'mock/pageMock/createPageApi.json',
			path: 'page/addPage'
		},
		getPageByIdApi: {
			serve: 'mock/pageMock/getPageByIdApi.json',
			path: 'page/getPageById'
		},
		getCascadingPageApi: {
			serve: 'mock/pageMock/getCascadingPageApi.json',
			path: '	page/getCascadingPage'
		},
		updatePageApi: {
			serve: 'mock/pageMock/updatePageApi.json',
			path: 'page/updatePage'
		},

		// Copy Writing CRUD
		getCopywritingListApi: {
			serve: 'mock/copywritingMock/getCopywritingListApi.json',
			path: 'copywriting/getCopywritingList'
		},
		getCopywritingByIdApi: {
			serve: 'mock/copywritingMock/getCopywritingListApi.json',
			path: 'copywriting/getCopywritingById'
		},
		createCopywritingApi: {
			serve: 'mock/copywritingMock/getCopywritingListApi.json',
			path: 'copywriting/addCopywriting'
		},
		updateCopywritingApi: {
			serve: 'mock/copywritingMock/updateCopywritingApi.json',
			path: 'copywriting/updateCopywriting'
		},
		deleteCopywritingByIdApi: {
			serve: 'mock/copywritingMock/deleteCopywritingByIdApi.json',
			path: 'copywriting/deleteCopywritingById'
		},
		downloadCopywritingApi: {
			serve: 'copywriting/downLoad',
			path: 'copywriting/downLoad'
		},

		// Log APIs
		getLogListApi: {
			serve: 'mock/logMock/getLogApi.json',
			path: 'log/getLogList'
		},

		// Auth & account
		loginUserApi: {
			serve: 'mock/loginMock/login.json',
			path:  'account/login'
		},
		registerUserApi: {
			serve: 'mock/loginMock/login.json',
			path:  'account/addAccount'
		},
		logoutUserApi: {
			serve: 'mock/loginMock/logout.json',
			path:  'account/logout'
		},
		getUserProfileApi: {
			serve: 'mock/accountMock/getProfile.json',
			path: 'account/profile'
		},
	}
};
export default apiConfig
